__turbopack_context__.v({
  "steps": "Steps-module-scss-module__Bpkspq__steps",
  "steps__arrow": "Steps-module-scss-module__Bpkspq__steps__arrow",
  "steps__content": "Steps-module-scss-module__Bpkspq__steps__content",
  "steps__copy": "Steps-module-scss-module__Bpkspq__steps__copy",
  "steps__decoration": "Steps-module-scss-module__Bpkspq__steps__decoration",
  "steps__item": "Steps-module-scss-module__Bpkspq__steps__item",
  "steps__number": "Steps-module-scss-module__Bpkspq__steps__number",
  "steps__title": "Steps-module-scss-module__Bpkspq__steps__title",
});
